// extracted by mini-css-extract-plugin
export var md = "_4j-4";
export var semantic = "_4j-5";
export var sm = "_4j-3";
export var text = "_4j-6";
export var toggleInput = "_4j-0";
export var toggleSwitch = "_4j-1";
export var xs = "_4j-2";